"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeepLinkItemType = void 0;

var _react = require("react");

var _router = require("@reach/router");

var _toString2 = _interopRequireDefault(require("lodash/toString"));

var _toUpper2 = _interopRequireDefault(require("lodash/toUpper"));

var _menu = require("../../menu");

var _ = require("../");

var _settings = require("../../settings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useDeepLinkItemType = function useDeepLinkItemType() {
  var _a;

  var settings = (0, _settings.useSettings)().data;
  var isDeeplinkFeature = (_a = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _a === void 0 ? void 0 : _a.DEEP_LINK;
  var dispatch = (0, _.useDeepLinkDispatch)();
  var itemType = (0, _.useDeepLinkState)().itemType;
  var category = (0, _toUpper2["default"])(itemType);
  var menuType = (0, _menu.useMenuType)(category);
  (0, _react.useEffect)(function () {
    var _a;

    if (isDeeplinkFeature && menuType) {
      var url = (0, _toString2["default"])(category === _menu.CustomPizza.CustomPizzaCode ? 'create-your-own' : menuType); // tslint:disable-next-line: strict-type-predicates

      var pathname = typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname);
      (0, _router.navigate)(pathname + "/" + url);
      dispatch({
        type: _.Actions.UNSET,
        payload: _.StateKeys.ItemType
      });
    }
  }, [dispatch, isDeeplinkFeature, category, menuType, itemType]);
};

exports.useDeepLinkItemType = useDeepLinkItemType;